export const MAX_ELEMENTS_TO_SHOW = 8;
export const THIRD_LEVEL_WITH_PICTOGRAM_MAX_ELEMENTS_TO_SHOW = 10;